import './index.scss'
import '../../assets/scripts/countNumber.js'
import '../../assets/scripts/jquery.fittext.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

function numScroll() {
  $(".number .num").each(function(){
    let num = $(this).attr('data-num')
    $(this).rollNum({
      deVal: num
    });
  })
}

$(document).ready(function(){
  $('.ny-banner h1').textillate();
  if($('.ny-banner h2').html() != ''){
    setTimeout(function(){
      $('.ny-banner h2').textillate();
    },800)
  }
})

$(document).scroll(function () {
  let scroH = $(document).scrollTop(); //滚动高度
  let viewH = $(window).height(); //可见高度
  let numTop = $('.num-cont').offset().top - viewH

  if(scroH > numTop){
    numScroll()
  }else{
    $(".number .num").each(function(){
      let num = $(this).attr('data-num')
      $(this).html(num);
    })
  }
})